import xlsx from "@/utils/excel-utils";
import { toast } from "sonner";
import moment from "moment";

const sheetNameMap = {
  make: "make",
  model: "model",
  grade: "grade",
  sponsoredViews: "ad views",
  sponsored: "ad clicks",
  advertisementClicks: "Advertisement Clicks",
  advertisementViews: "Advertisement Views",
};

export async function createAnalyticsExcel(
  dashboardData,
  startDate,
  endDate,
  selectedState
) {
  let keys = [];

  Object.keys(dashboardData).forEach((key) => {
    if (dashboardData[key].values.length > 0) {
      keys.push(key);
    }
  });

  if (keys.length === 0) {
    toast.info("No data to export");
    return;
  }

  const sheetName = `export_${moment(startDate).format("MMM/D/YYYY")}_${moment(
    endDate
  ).format("MMM/D/YYYY")}_${selectedState}`;

  const wb = xlsx.utils.book_new();
  keys.forEach((key) => {
    // const data = convertToCSVWithHeaders(dashboardData[key]);
    const data = [dashboardData[key].header, ...dashboardData[key].values];
    /* create worksheet */
    const ws = xlsx.utils.aoa_to_sheet(data);
    /* create workbook and export */
    xlsx.utils.book_append_sheet(wb, ws, sheetNameMap[key] || "Finance Clicks");
  });

  xlsx.writeFile(wb, `${sheetName}.xlsx`);
}
